export default "__VITE_ASSET__De_P03Bl__"